/**
 * kik-feel-inspired.js
 *
 * On viewports <= 820px, moves any element with [data-append-to] or
 * [data-prepend-to] to the specified CSS selector target.
 * Restores to original DOM position on > 820px (desktop).
 */
(function () {
  const MQ          = window.matchMedia('(max-width: 820px)');
  const RETRY_LIMIT = 20;
  const RETRY_DELAY = 150; // ms

  function normalizeSelector(val) {
    if (!val) return null;
    val = val.trim();
    if (val[0] !== '.' && val[0] !== '#' && val[0] !== '[') return '.' + val;
    return val;
  }

  function tryMove(el, retries) {
    const appendSel  = normalizeSelector(el.dataset.appendTo);
    const prependSel = normalizeSelector(el.dataset.prependTo);
    const sel        = appendSel || prependSel;
    if (!sel) return;

    const target = document.querySelector(sel);

    if (!target) {
      if (retries < RETRY_LIMIT) setTimeout(() => tryMove(el, retries + 1), RETRY_DELAY);
      return;
    }

    if (el.parentElement === target) return;

    if (appendSel) {
      target.appendChild(el);
    } else {
      target.prepend(el);
    }
  }

  function restore(el, originalParent, originalNextSibling) {
    if (!el || !originalParent) return;
    if (el.parentElement === originalParent) return;
    if (originalNextSibling) {
      originalParent.insertBefore(el, originalNextSibling);
    } else {
      originalParent.appendChild(el);
    }
  }

  function setupElement(el) {
    const originalParent      = el.parentElement;
    const originalNextSibling = el.nextElementSibling;

    function handleChange(e) {
      if (e.matches) {
        tryMove(el, 0);
      } else {
        restore(el, originalParent, originalNextSibling);
      }
    }

    handleChange(MQ);
    MQ.addEventListener('change', handleChange);
  }

  function init() {
    const elements = document.querySelectorAll('[data-append-to], [data-prepend-to]');
    elements.forEach(setupElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
